import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Sidebar from "../Component/Sidebar";
import { UserContex } from "../context API/UserContext";
import edit from "./../images/pencil.png"
import delet from "./../images/delete.png"
const ManageBlog = ({ logout }) => {
  const [blogs, setBlogs] = useState([]);
  const [userData, setUserData] = useContext(UserContex);
  const navigate = useNavigate();
  useEffect(() => {
    axios
      .get("https://back.waratechnology.com/api/blog/getblog")
      .then((res) => {
        console.log(res);
        setBlogs(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const handledelete = async(id) => {
    console.log(id)
    await axios
      .delete("https://back.waratechnology.com/api/blog/delblog/"+id)
      .then((res) =>{
         console.log(res.data)
        })
      .catch((err) => console.log(err));
    window.location.reload();
  };
  useEffect(() => {
    if (!userData.user) {
      navigate("/login");
    }
  });
  return (
    <div className="flex">
      <Sidebar logout={logout} />
      <div className="container mx-auto p-4 ml-80">
        <h1 className="text-3xl font-bold mb-4">Blog Posts</h1>
        <Link
          to="/addblog"
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        >
          Create New Post
        </Link>

        <div className="mt-4 overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="border-collapse border border-slate-500 bg-gray-200">
              <tr>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-slate-700"
                >
                  Title
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-slate-700"
                >
                  Description
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-slate-700"
                >
                  image
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-slate-700"
                >
                  Date
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-slate-700"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {blogs.map((data, index) => (
                <tr>
                  <td className="px-6 py-3 text-left text-xs font-medium text-gray-900  tracking-wider border border-slate-700">
                    {data.blog_highlight}
                  </td>
                  <td className="px-6 py-3 text-left text-xs font-medium text-gray-900  tracking-wider border border-slate-700">
                    {data.blog_description}
                  </td>
                  <td className="px-6 py-3 text-left text-xs font-medium text-gray-900  tracking-wider border border-slate-700">
                    <img
                      className="w-24 h-24"
                      src={"https://back.waratechnology.com" + data.blog_image}
                    />
                  </td>
                  <td className="px-6 py-3 text-center items-center text-xs font-medium text-gray-900 uppercase tracking-wider border border-slate-700">
                    {data.blog_date}
                  </td>
                  <td className="flex justify-between w-full h-full items-center gap-1 px-6 py-10 text-center text-xs font-medium text-gray-900 uppercase tracking-wider border border-l-0 border-t-0 border-slate-700 ">
                    <Link
                      to={`/updateblog/${data.id}`}
                      className="mr-4 py-2 text-white px-3 border-none "
                    >
                      <img className="w-7" src={edit} alt="" />
                    </Link>

                    <img
                      onClick={(e) => handledelete(data.id)}
                      className="w-7 cursor-pointer"
                      src={delet}
                      alt=""
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ManageBlog;
